<template>
  <div class="properties-centent kk-checkbox">
    <div class="properties-body">
      <a-empty
        class="hint-box"
        v-show="!selectItem || selectItem.key === ''"
        description="请先选择题目"
      />
      <div style="color: red;" v-if="selectItem.key !== '' && !isDefined(selectItem.itemType)">
        <a-icon type="info-circle" style="color: red" />
        <span>  请先保存题目以展示更多属性</span>
        <hr/>
      </div>
      <a-form v-show="selectItem.key !== ''">
        <!-- <a-form-item v-if="selectItem.common && isDefined(selectItem.common.id) && selectItem.type !== 'emptyCard'" label="ID">
          <Input v-model="selectItem.common.id" placeholder="请输入" readonly disabled/>
        </a-form-item>
        <a-form-item v-if="selectItem.common && isDefined(selectItem.common.code) && selectItem.type !== 'emptyCard'" label="元素代码">
          <Input v-model="selectItem.common.code" placeholder="请输入" />
        </a-form-item> -->
        <a-form-item v-if="isDefined(selectItem.label) && selectItem.type !== 'emptyCard'" label="题目名称">
          <Textarea v-model="selectItem.label" placeholder="请输入" />
        </a-form-item>
        <a-form-item class="ant-form-item-vertical" v-if="isDefined(selectItem.sequence)" label="题号">
          <Input v-model="selectItem.sequence" placeholder="请输入" />
        </a-form-item>
        <a-form-item  class="ant-form-item-vertical" v-if="isDefined(selectItem.required)" label="必填">
          <ASwitch v-model="selectItem.required" />
        </a-form-item>
        <a-form-item class="ant-form-item-vertical" v-if="isDefined(selectItem.scale)" label="量表题目">
          <ASwitch v-model="selectItem.scale" />
        </a-form-item>
        <a-form-item class="ant-form-item-vertical" v-if="isDefined(selectItem.conceal)" label="隐藏元素">
          <ASwitch v-model="selectItem.conceal" />
        </a-form-item>
        <a-form-item class="ant-form-item-vertical" v-if="isDefined(selectItem.disabled)" label="禁止输入">
          <ASwitch v-model="selectItem.disabled" />
        </a-form-item>
        <a-form-item class="ant-form-item-vertical" v-if="isDefined(selectItem.important)" label="核心题目">
          <ASwitch v-model="selectItem.important" />
        </a-form-item>
        <a-form-item class="ant-form-item-vertical" v-if="isDefined(selectItem.draw)" label="画图题目">
          <ASwitch v-model="selectItem.draw" />
        </a-form-item>
        <a-form-item class="ant-form-item-vertical" v-if="isDefined(selectItem.img)" label="题目图片">
          <j-image-upload class="avatar-uploader" :customWidth="45" text="上传" v-model="selectItem.img" :bizPath="`knowledge/form/${selectForm.id}`"> </j-image-upload>
        </a-form-item>
        <a-form-item v-if="isDefined(selectItem.isAddRow)" label="添加删除行">
           <ASwitch v-model="selectItem.isAddRow" />
        </a-form-item>
        <a-form-item
          v-if="!isDefined(options.readme) && parentItem && parentItem.options && parentItem.options.options && parentItem.options.options.length > 0 && selectItem.common"
          prop="parentValueList"
          label="依赖项值">
          <a-select placeholder="请选择依赖项值" v-model="selectItem.common.parentValueList" mode="multiple">
            <a-select-option v-for="(item,index) in parentItem.options.options" :key="index" :value="item.value">{{item.label}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-if="isDefined(selectItem.description)" label="描述">
          <Textarea
            v-model="selectItem.description"
            placeholder="请输入"
          ></Textarea>
        </a-form-item>
        <a-form-item v-if="isDefined(selectItem.help) && selectItem.type !== 'emptyCard'" label="引导语">
          <Textarea
            v-model="selectItem.help"
            placeholder="请输入"
          ></Textarea>
        </a-form-item>

        <a-form-model-item v-if="selectItem.type === 'time'||selectItem.type === 'hour'||selectItem.type === 'minute'" label="时间类型">
                    <a-select
                      placeholder="请选择"
                      v-model="selectItem.typeNew"
                    >
                      <a-select-option :value="item.value" v-for="(item,index) in timeType" :key="index">{{item.text}}</a-select-option>
                    </a-select>
        </a-form-model-item>

         <a-form-model-item v-if="selectItem.type === 'date'||selectItem.type === 'dateyear'" label="日期类型">
            <a-select
              placeholder="请选择"
              v-model="selectItem.typeNew"
            >
              <a-select-option :value="item.value" v-for="(item,index) in dateType" :key="index">{{item.text}}</a-select-option>
            </a-select>
        </a-form-model-item>

         <a-form-item v-if="isDefined(selectItem.isTableCell)" label="输入为复选框">
           <ASwitch v-model="selectItem.isChecked" />
        </a-form-item>
        <a-form-item v-if="isDefined(selectItem.isTableCell)" label="输入为下拉选择框">
           <ASwitch v-model="selectItem.isRadio" />
        </a-form-item>        

        <!-- 选项配置及动态数据配置 start -->
        <a-form-item v-if="isDefined(options.options)" label="选项配置">
          <CsimChangeOption :selectForm="selectForm" v-show="!options.dynamic" @refreshOptions="refreshOptions" v-model="options.options" />
        </a-form-item>
        <!-- 选项配置及动态数据配置 end -->

        <a-form-item class="ant-form-item-vertical" v-if="isDefined(options.min)" label="最小值">
          <InputNumber v-model="options.min" placeholder="请输入" />
        </a-form-item>
        <a-form-item class="ant-form-item-vertical" v-if="isDefined(options.max)" label="最大值">
          <InputNumber v-model="options.max" placeholder="请输入" />
        </a-form-item>

        <a-form-item class="ant-form-item-vertical" v-if="isDefined(options.reDecimal)" label="允许小数点">
          <ASwitch v-model="options.reDecimal" />
        </a-form-item>
        <a-form-item class="ant-form-item-vertical" v-if="isDefined(options.decimalPoint)" label="小数点位数" >
          <InputNumber v-model="options.decimalPoint" placeholder="请输入" :min="0" :precision="0" />            
        </a-form-item>
        <a-form-item class="ant-form-item-vertical" v-if="isDefined(options.maxLength)" label="最大长度">
          <InputNumber v-model="options.maxLength" placeholder="请输入" />
        </a-form-item>
        <a-form-item class="ant-form-item-vertical" v-if="isDefined(options.minLength)" label="最小长度">
          <InputNumber v-model="options.minLength" placeholder="请输入" />
        </a-form-item>
        <a-form-item class="ant-form-item-vertical" v-if="isDefined(options.unit)" label="单位">
          <Input v-model="options.unit" placeholder="请输入" />
        </a-form-item>
        <a-form-item class="ant-form-item-vertical" v-if="isDefined(options.addonAfter)" label="单位">
          <Input v-model="options.addonAfter" placeholder="请输入" />
        </a-form-item>
        <a-form-item v-if="isDefined(options.checkReg)" label="校验正则">
          <Input v-model="options.checkReg" placeholder="请输入" />
        </a-form-item>

        <a-form-item class="ant-form-item-vertical" v-if="isDefined(selectItem.itemType) && (kDesignType === 'CONFIG_FORM' || kDesignType === 'SCHEMA_DESIGN') && selectItem.type !== 'emptyCard'" label="量表计算">
          <a @click="dataInputModel('1')">点击设置</a>
        </a-form-item>
        <a-form-item class="ant-form-item-vertical" v-if="isDefined(selectItem.itemType) && (kDesignType === 'CONFIG_FORM' || kDesignType === 'SCHEMA_DESIGN') && selectItem.type !== 'emptyCard'" label="数据填入">
          <a @click="dataInputModel('2')">点击设置</a>
        </a-form-item>
        <a-form-item class="ant-form-item-vertical" v-if="isDefined(selectItem.itemType) && (kDesignType === 'CONFIG_FORM' || kDesignType === 'SCHEMA_DESIGN') && selectItem.type !== 'emptyCard'" label="级联填入">
          <a @click="dataInputModel('3')">点击设置</a>
        </a-form-item>

        <a-form-item class="ant-form-item-vertical" v-if="isDefined(selectItem.display)" label="题目显隐">
          <ASwitch />
        </a-form-item>

        <!-- <a-form-item v-if="isDefined(options.readme)" label="操作提示">
          <span>{{ options.readme }}</span>
        </a-form-item> -->
      </a-form>
    </div>

    <formula-model ref="dataInputModalForm" @ok="modalFormOk"></formula-model>
    <csim-config-form-item-visible-modal ref="csimConfigFormItemVisiableModal" @ok="modalFormVisiableOk" :selectItem="selectItem"></csim-config-form-item-visible-modal>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import CsimChangeOption from "@views/tempconfig/formDesign/csim/CsimChangeOption.vue";
import kCheckbox from "../../KCheckbox/index.vue";
import { pluginManager } from "../../../utils/index";
import FormulaModel from '@views/tempconfig/formula/FormulaModel';
import CsimConfigFormItemVisibleModal from '@views/tempconfig/formDesign/csim/CsimConfigFormItemVisibleModal';
import JImageUpload from '@comp/jeecg/JImageUpload'
import { eraseUtils } from "../../../utils/index";

const Input = pluginManager.getComponent("input").component;
const InputNumber = pluginManager.getComponent("number").component;
const Rate = pluginManager.getComponent("rate").component;
const Checkbox = pluginManager.getComponent("checkbox").component;
const Radio = pluginManager.getComponent("radio").component;
const RadioButton = pluginManager.getComponent("radioButton").component;
const RadioItem = pluginManager.getComponent("radioItem").component;
const Textarea = pluginManager.getComponent("textarea").component;
const Select = pluginManager.getComponent("select").component;
const ColorPicker = pluginManager.getComponent("colorPicker").component;
const ASwitch = pluginManager.getComponent("switch").component;

/**
 * 最终被使用的类型只有：
 * 'radio', 'uploadFile', 'slider', 'input', 'checkbox', 'number', 'time', 'date'
 */
export default {
  name: "csimFormAttribute",
  components: {
    CsimChangeOption,
    kCheckbox,
    ColorPicker,
    Input,
    InputNumber,
    Rate,
    ASwitch,
    Checkbox,
    Radio,
    RadioItem,
    RadioButton,
    Textarea,
    Select,
    FormulaModel,
    JImageUpload,
    CsimConfigFormItemVisibleModal,
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      disableMixinCreated: true,
      dateType: [{
                          text:'日期',
                          value:'date'
                        },{
                          text:'年月',
                          value:'dateyear'
                        }],
        timeType: [{
                          text:'时分秒',
                          value:'hour'
                        },{
                          text:'时分',
                          value:'time'
                        },{
                          text:'分秒',
                          value:'minute'
                        },],
    };
  },
  computed: {
    options() {
      return this.selectItem.options || {};
    }
  },
  props: {
    selectItem: {
      type: Object,
      required: true
    },
    selectForm: {
      type: Object,
      required: false
    },
    parentItem: {
      type: Object,
      required: false
    },
    hideModel: {
      type: Boolean,
      default: false
    },
    hideTypeModel: {
      type: Boolean,
      default: false
    },
    kDesignType:{
      type:String,
      default:''
    },
    projectId:{
      type:String,
      default:''
    },
  },
  watch: {
    selectItem: {
      immediate:true,
      handler:function(){
        if (!this.selectItem.common) {
          this.$set(this.selectItem,'common',{})
        }
        if(this.selectItem.common.parentValue){
          this.$set(this.selectItem.common,'parentValueList',this.selectItem.common.parentValue.split(','))
        }else{
          this.$set(this.selectItem.common,'parentValueList',[])
        }

        if ((this.selectItem.type === 'date' || this.selectItem.type === 'dateyear') && !this.isDefined(this.selectItem.typeNew)) {
          this.$set(this.selectItem, 'typeNew', this.selectItem.type === 'dateyear' ? 'dateyear' : 'date')
        }

        if (this.selectItem.type === 'dateyear') {
          this.$set(this.selectItem, 'type', 'date')
        }

        if (this.selectItem.type === 'date' && this.isDefined(this.selectItem.typeNew)) {
          this.syncDateTypeOption(this.selectItem.typeNew)
        }

        if (!this.selectItem.common.code) {
          this.$set(this.selectItem.common, 'code', eraseUtils.generateShortId());
        }
      }
    },
    'selectItem.typeNew': function(newVal) {
      if (this.selectItem.type === 'date') {
        this.syncDateTypeOption(newVal)
      }
    }
  },
  methods: {
    /**
     * 判断是否已定义
     * @param {*} value
     */
    isDefined(value) {
      return typeof value !== "undefined";
    },

    syncDateTypeOption(typeNew) {
      if (!this.selectItem.options) {
        this.$set(this.selectItem, 'options', {});
      }

      if (typeNew === 'dateyear') {
        this.$set(this.selectItem.options, 'format', 'YYYY-MM');
        this.$set(this.selectItem.options, 'placeholder', '请选择年月');
      } else {
        this.$set(this.selectItem.options, 'format', 'YYYY-MM-DD');
        this.$set(this.selectItem.options, 'placeholder', '请选择日期');
      }
    },

    dataInputModel(typeTab) {
      this.$refs.dataInputModalForm.title="公式";
      this.$refs.dataInputModalForm.disableSubmit = true;

      let formItem = eraseUtils.parseSingleFormDesignData(this.selectForm.formCode, this.selectForm.id, this.selectItem, null);

      getAction('/tempconfig/formula/getInfo', { type: typeTab, formId: this.selectForm.id, formItemId: formItem.id }).then(res => {
        if (res.success){
          if(res.result) {
            this.$refs.dataInputModalForm.edit(res.result);
          } else {
            this.$refs.dataInputModalForm.edit({
              type: typeTab,
              selectForm: this.selectForm,
              selectItem: formItem
            });
          }
        } else {
          this.$message.error('后台请求异常')
        }    
      })
    },

    formVisiableModel: function() {
      this.$refs.csimConfigFormItemVisiableModal.init();
      this.$refs.csimConfigFormItemVisiableModal.disableSubmit = false;
    },

    modalFormVisiableOk: function() {

    },

    refreshOptions: function() {
      this.$emit('refreshOptions');
    },
    
    // 获取父题选项标签
    getParentValueLabels(parentValueStr) {
      if (!parentValueStr) return '';
      
      // 分割选项值字符串
      const values = parentValueStr.split(',');
      
      // 查找对应选项的标签
      const labels = [];
      
      // 遍历所有题目查找匹配的父题
      const findParentQuestion = (items) => {
        for (let item of items) {
          // 如果当前题目就是我们要找的父题
          if (item.common && item.common.code === this.selectItem.common.parentCode) {
            if (item.options && item.options.options) {
              values.forEach(value => {
                const option = item.options.options.find(opt => opt.value === value);
                if (option) {
                  labels.push(option.label);
                }
              });
            }
            return true;
          }
          
          // 递归查找嵌套结构
          if (item.list && Array.isArray(item.list)) {
            if (findParentQuestion(item.list)) return true;
          }
          
          if (item.columns && Array.isArray(item.columns)) {
            for (let column of item.columns) {
              if (column.list && Array.isArray(column.list)) {
                if (findParentQuestion(column.list)) return true;
              }
            }
          }
          
          if (item.trs && Array.isArray(item.trs)) {
            for (let tr of item.trs) {
              if (tr.tds && Array.isArray(tr.tds)) {
                for (let td of tr.tds) {
                  if (td.list && Array.isArray(td.list)) {
                    if (findParentQuestion(td.list)) return true;
                  }
                }
              }
            }
          }
        }
        return false;
      };
      
      // 从表单数据中查找父题
      if (this.selectForm && this.selectForm.list) {
        findParentQuestion(this.selectForm.list);
      }
      
      return labels.join(', ');
    }
  }
};
</script>
<style lang="less" scoped>
.ant-form-item-vertical {
  display: flex;
  /deep/.ant-form-item-label {
    align-content: center;
  }
}

.avatar-uploader{
  /deep/ .ant-upload-picture-card-wrapper {
    display: flex;
  }
  /deep/ .ant-upload {
    width:40px !important;
    height:40px !important;
    /deep/ .avatar-view {
      width:40px !important;
      height:40px !important;
    }
  }
}

.options-row {
  height: 70px;
  display: flex;
  align-items: center;
  flex-direction: row;
}
</style>